export const units = (...gridUnits: number[]): string => gridUnits.map(u => `${u * 0.5}rem`).join(' ');
